const isValid = (value: string | null): value is string =>
  [null, undefined, ''].includes(value);

const getStorageItem = <T>(key: string, defaultValue: T = {} as T): T => {
  try {
    const value = localStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

export default getStorageItem;
